import {
  BaseQueryFn,
  fetchBaseQuery,
  FetchBaseQueryError,
  FetchBaseQueryMeta,
} from '@reduxjs/toolkit/dist/query';
import { BaseQueryApi } from '@reduxjs/toolkit/dist/query/baseQueryTypes';
import type {
  FetchArgs,
  FetchBaseQueryArgs,
} from '@reduxjs/toolkit/dist/query/fetchBaseQuery';

import { ApiServices, getApiUrl } from 'src/constants/api.constants';
import AuthService from 'src/services/api/auth.service';

export const baseQuery = <T>(
  serviceName: ApiServices,
  options?: FetchBaseQueryArgs,
) => {
  return (
    args: string | FetchArgs | string[] | FetchArgs[] | null,
    WebApi: BaseQueryApi,
    extraOptions: Record<string, unknown>,
  ) => {
    if (args === null) return { data: null };

    const baseQueryFunction = fetchBaseQuery({
      prepareHeaders: (headers) => {
        const token = AuthService.getAccessToken();
        headers.set('authorization', `Bearer ${token}`);
        return headers;
      },
      ...options,
      baseUrl: getApiUrl(serviceName),
    }) as BaseQueryFn<
      string | FetchArgs,
      T,
      FetchBaseQueryError,
      Record<string, unknown>,
      FetchBaseQueryMeta
    >;

    return baseQueryFunction(
      Array.isArray(args) ? args[0] : args,
      WebApi,
      extraOptions,
    );
  };
};
